// extracted by mini-css-extract-plugin
module.exports = {"DarkTheme__link___2D8Pz":"DarkTheme__link___2D8Pz","DarkTheme__disabled___2AgfC":"DarkTheme__disabled___2AgfC"};